import React from "react";
import { Link } from "react-router-dom";
import wic from "../../../assets/images/wic.jpg";
import BreadcrumbDetailed from "components/Common/BreadcrumbDetailed";
import BlogDetailImage from "../../../assets/images/blog-detail.jpg";
import "./blog-detail.scss";

function BlogDetail() {

const breadcrumbList = [{ lable: "Blog Detail", link: "" }];

const blogContent = {
  title: "ALBACORE, WE WANT MORE!",
  author: "Meredith McGrath RD, LDN",
  date: "November 12, 2024",
  byline: "Madelyn Tsakonas, Dietetic Intern, West Chester University",
  intro:
    "Ever find those old cans of tuna in your pantry and think to yourself “what can I possibly do with this?”. The answer is simple: SO much! It is not only affordable and shelf stable but it’s high in nutrients as well. The perfect option for those busy days when you need something quick and convenient. There are many benefits to canned tuna, and these yummy recipes will keep you wanting more. We all know eating healthy on a budget can be tricky. But canned tuna makes it one step easier!",
  recipes: [
    {
      id: 1,
      name: "Greek Tuna Salad Pockets",
      image: wic,
      servings: 4,
      prepTime: "10m",
      calories: 210,
      description:
        "White albacore tuna is my favorite canned fish for recipes like this one. It is packed with vitamins and minerals, healthy fats, and protein solely from the tuna itself. It also has a variety of vegetables which only adds to the health benefits. And it’s delicious, nonetheless!",
      ingredients: [
        "2 tablespoons lemon juice",
        "1 tablespoon olive oil",
        '1 1/2 teaspoons McCormick® Oregano Leaves',
        "1/2 teaspoon McCormick® Garlic Powder",
        "1 pouch (7 ounces) albacore tuna, packed in water",
        "1/2 cup chopped tomato",
        "1/4 cup finely chopped red onion",
        "1/4 cup crumbled reduced fat feta cheese",
        "2 whole wheat pita breads (6 1/2-inch)",
        "1 cup baby spinach leaves",
      ],
      directions: [
        "Mix lemon juice, oil, oregano and garlic powder in medium bowl until well blended. Add tuna, tomato, red onion and feta cheese; toss lightly. Cover.",
        "Refrigerate at least 1 hour or until ready to serve.",
        "Cut pita bread in half. Line with spinach leaves. Spoon tuna mixture into pita pockets.",
      ],
      recipeLink: "https://www.mccormick.com/recipes/main-dishes/greek-tuna-salad-pockets",
    },
    {
      id: 2,
      name: "Tuna casserole",
      image: wic,
      servings: 12,
      prepTime: "10m",
      cookTime: "40m",
      calories: 299,
      description:
        "This casserole is perfect for feeding a group, especially with the affordability of canned tuna. It takes a basic casserole and turns it into something yummy and budget friendly!",
      ingredients: [
        "1 package (12 ounces) wide egg noodles",
        "8 tablespoons (1 stick) butter, divided",
        "1 1/4 cups panko",
        "2 teaspoons parsley flakes",
        "1 medium yellow onion, finely chopped",
        "1/2 medium red bell pepper, finely chopped",
        "2 cups (6 ounces) white mushrooms, finely chopped",
        "2 teaspoons McCormick® Garlic Powder",
        "1/4 cup flour",
        "1 1/2 teaspoons McCormick® Sea Salt Grinder",
        "1/2 teaspoon McCormick® Pure Ground Black Pepper",
        "3 1/2 cups whole milk",
        "3 cans (6 ounces each) albacore tuna in water, drained well",
        "1 cup frozen peas",
      ],
      directions: [
        "Preheat oven to 400°F. Spray 13×9-inch baking dish with no stick cooking spray; set aside. Cook noodles in salted water as directed on package. Rinse with cool water. Drain well and set aside.",
        "Meanwhile, melt 4 tablespoons of the butter in large deep skillet on medium-high heat. Add panko, cook and stir just until lightly browned, about 5 minutes. Transfer to small bowl. Stir in parsley; set aside. Carefully wipe out pan.",
        "Melt remaining 4 tablespoons butter in same skillet on medium-high heat. Add onion and bell pepper; cook and stir 3 minutes until softened. Stir in mushrooms and garlic powder; cook, stirring occasionally, until mushrooms are tender about 3 minutes. Sprinkle flour into skillet. Add salt and pepper. Cook and stir 1 minute. Gradually whisk in milk. Bring to gentle boil. Reduce heat and simmer 3 minutes or until thickened. Remove from heat. Gently stir in noodles, tuna and peas. Spoon into prepared baking dish. Sprinkle top evenly with panko mixture.",
        "Bake 20 to 25 minutes or until top is lightly browned. Let stand 5 to 10 minutes before serving.",
      ],
      recipeLink: "https://www.mccormick.com/recipes/main-dishes/tuna-casserole",
    },
    {
      id: 3,
      name: "Sheet Pan Tuna Melt",
      image: wic,
      servings: 4,
      prepTime: "10m",
      cookTime: "3m",
      calories: 300,
      description:
        "This recipe is a fun and different way to use tuna, incorporating McCormick’s very own tartar sauce for a tangy touch! The convenience of canned tuna is unmatched since it can stay good for about 2-5 years if stored correctly. Perfect for the days you need a quick meal and if you’ve been needing an excuse to use that tuna you’ve had in the pantry for… let’s not talk about how long.",
      ingredients: [
        "1 large tomato, cut into 4 slices",
        "2 English muffins, halved",
        "2 cans (5 ounces each) white albacore tuna packed in water, drained",
        "1/4 cup McCormick® Tartar Sauce",
        "2 tablespoons finely chopped celery",
        "1 cup shredded Cheddar cheese",
        "4 lettuce leaves",
      ],
      directions: [
        "Preheat oven to broil on high. Place tomato slices on one side of large, shallow, foil-lined baking pan sprayed with no stick cooking spray. Place muffin halves, cut side up, on other side of pan. Set aside.",
        "Mix tuna, tartar sauce and celery in medium bowl until blended. Mound tuna salad evenly onto tomato slices. Top with cheese.",
        "Broil 2 to 3 minutes or until cheese is melted and muffins are lightly toasted. Place lettuce on toasted muffins. Top with tomato-tuna melt.",
      ],
      recipeLink: "https://www.mccormick.com/recipes/main-dishes/sheet-pan-tuna-melt",
    },
  ],
};

const recentPosts = [
  { title: "Albacore, We Want More!", link: "/" },
  { title: "5 REFRESHING SUMMER MEALS WHEN IT’S TOO HOT OUTSIDE", link: "/" },
  { title: "HOW TO BEST USE YOUR SUN BUCKS TO FUEL YOUR SUMMER SAVINGS", link: "/" },
  { title: "Top Five Favorite Football Fingerfoods", link: "/" },
  { title: "Totally Tacos (not just for Tuesday!)", link: "/" },
];

const categories = [
  {name: "Ask Meredith" },
  {name: "HealthCents" },
  {name: "Hot Topics" },
  {name: "Lifestyle" },
  {name: "New at Redner’s" },
  {name: "News and Events" },
  {name: "Recipes" },
  {name: "Seasonal Tips" },
  {name: "Uncategorized" },
];



  return (
    <>
      <BreadcrumbDetailed
        breadcrumbList={breadcrumbList}
        title="Blog Detail"
      />

      <div className="blog-detail-section">
        <div className="container">
          <div className="blog-image">
            <img src={BlogDetailImage} className="img-fluid" alt="blog image" />
          </div>

          <div className="main-content-container">
            <div className="left-content">
              <h2>{blogContent.title}</h2>
              <p>
                {blogContent.date} by {blogContent.author}
              </p>
              <p>
                By: <span>{blogContent.byline}</span>
              </p>
              <p>{blogContent.intro}</p>

              {blogContent.recipes.map((recipe) => (
                <div key={recipe.id}>
                  <p>
                    <strong>
                      <u>{recipe.name}</u>
                    </strong>{" "}
                    <img
                      className="alignright right-img"
                      src={recipe.image}
                      alt={recipe.name}
                    />
                  </p>
                  <p>
                    Servings: {recipe.servings} | prep time: {recipe.prepTime}{" "}
                    {recipe.cookTime && <>| cook time: {recipe.cookTime} </>}|{" "}
                    {recipe.calories} calories
                  </p>
                  <p>{recipe.description}</p>

                  <p>Ingredients</p>
                  <ul>
                    {recipe.ingredients.map((item) => (
                      <li>
                        {item.includes("McCormick®") ? (
                          <Link to="/">{item}</Link>
                        ) : (
                          item
                        )}
                      </li>
                    ))}
                  </ul>

                  <p>Directions</p>
                  <ol>
                    {recipe.directions.map((step) => (
                      <li>{step}</li>
                    ))}
                  </ol>

                  <p>
                    Recipe: <Link to={recipe.recipeLink}>{recipe.recipeLink}</Link>
                  </p>
                  <p>&nbsp;</p>
                </div>
              ))}
            </div>

            <div className="right-content">
              <div className="recent-posts">
                <h2>Recent Posts</h2>
                <ul>
                  {recentPosts.map((post, idx) => (
                    <li key={idx}>
                      <Link to={post.link}>{post.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="categories">
                <h2>CATEGORIES</h2>
                <select name="categories" id="categories">
                  <option value="">Select Category</option>
                  {categories.map((cat) => (
                    <option>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlogDetail;
